"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPortalSettings = exports.getUpdateSubscriptionDefinitionsRequestStatus = exports.getUpdateSubscriptionDefinitionRequestStatus = exports.getDeleteSubscriptionTranslationRequestStatus = exports.getCreateSubscriptionTranslationRequestStatus = exports.getCreateSubscriptionDefinitionRequestStatus = exports.getFetchSubscriptionDefinitionsRequestStatus = exports.getSubscriptionLanguages = exports.getSubscriptionDefinitionIds = exports.getSubscriptionDefinitions = void 0;

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var _constants = require("./constants");

var getSubscriptionDefinitions = function getSubscriptionDefinitions(state) {
  return state.modules.marketing.email.entities.subscriptionDefinitions;
};

exports.getSubscriptionDefinitions = getSubscriptionDefinitions;

var getTypesTableFilter = function getTypesTableFilter(state) {
  return state.modules.marketing.email.interactions.get('typesTableFilter');
};

var getTypesTableLanguageFilter = function getTypesTableLanguageFilter(state) {
  return state.modules.marketing.email.interactions.get('typesTableLanguageFilter');
};

var getSubscriptionDefinitionIds = (0, _reselect.createSelector)([getSubscriptionDefinitions, getTypesTableFilter, getTypesTableLanguageFilter], function (types, statusFilter, languageFilter) {
  return types.filter(function (type) {
    var rightStatus = statusFilter === _constants.TypeFilter.ACTIVE && type.active || statusFilter === _constants.TypeFilter.INACTIVE && !type.active || statusFilter !== _constants.TypeFilter.ACTIVE && statusFilter !== _constants.TypeFilter.INACTIVE && true;
    var rightLanguage = languageFilter === 'default' || type.languageCodes.has(languageFilter);
    return rightStatus && rightLanguage;
  }).sortBy(function (type) {
    return type.order;
  }).map(function (type) {
    return "" + type.id;
  }).toArray();
});
exports.getSubscriptionDefinitionIds = getSubscriptionDefinitionIds;
var getSubscriptionLanguages = (0, _reselect.createSelector)([getSubscriptionDefinitions], function (types) {
  var languageCodes = (0, _immutable.Set)();
  var languageOptions = [];
  types.forEach(function (type) {
    languageCodes = languageCodes.concat(type.languageCodes);
  });
  languageOptions = languageCodes.map(function (code) {
    return {
      text: _I18n.default.text("SharedI18nStrings.languageNames." + code),
      value: code
    };
  });
  languageOptions = languageOptions.toArray();
  languageOptions.unshift({
    text: _I18n.default.text('marketing.email.languageFilter.default'),
    value: 'default'
  });
  return languageOptions;
});
exports.getSubscriptionLanguages = getSubscriptionLanguages;
var getFetchSubscriptionDefinitionsRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionDefinitionsActionTypes.FETCH_SUBSCRIPTION_DEFINITIONS);
exports.getFetchSubscriptionDefinitionsRequestStatus = getFetchSubscriptionDefinitionsRequestStatus;
var getCreateSubscriptionDefinitionRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_DEFINITION);
exports.getCreateSubscriptionDefinitionRequestStatus = getCreateSubscriptionDefinitionRequestStatus;
var getCreateSubscriptionTranslationRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_TRANSLATION);
exports.getCreateSubscriptionTranslationRequestStatus = getCreateSubscriptionTranslationRequestStatus;
var getDeleteSubscriptionTranslationRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionDefinitionsActionTypes.DELETE_SUBSCRIPTION_TRANSLATION);
exports.getDeleteSubscriptionTranslationRequestStatus = getDeleteSubscriptionTranslationRequestStatus;
var getUpdateSubscriptionDefinitionRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITION);
exports.getUpdateSubscriptionDefinitionRequestStatus = getUpdateSubscriptionDefinitionRequestStatus;
var getUpdateSubscriptionDefinitionsRequestStatus = (0, _getRequestStatus.default)(_actions.SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITIONS);
exports.getUpdateSubscriptionDefinitionsRequestStatus = getUpdateSubscriptionDefinitionsRequestStatus;

var getPortalSettings = function getPortalSettings(state) {
  return state.portalSettings.get('response', (0, _immutable.List)([])).toJS();
};

exports.getPortalSettings = getPortalSettings;